// AUTO-GENERATED FILE. Do not edit.
import { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import { PokeType } from "types/pokemon/poke-type";

export const cobalion: PokeData = {
  "id": 638,
  "name": "cobalion",
  "height": 21,
  "weight": 2500,
  "base_experience": 261,
  "types": [
    PokeType.STEEL,
    PokeType.FIGHTING
  ],
  "api_moves": [
    "swords-dance",
    "double-kick",
    "take-down",
    "leer",
    "quick-attack",
    "metal-claw",
    "helping-hand",
    "metal-burst",
    "close-combat",
    "iron-head",
    "quick-guard",
    "retaliate",
    "work-up",
    "sacred-sword"
  ],
  "moves": [
    "double-kick",
    "leer",
    "quick-attack",
    "metal-claw",
    "metal-burst",
    "close-combat",
    "karate-chop",
    "magnet-bomb",
    "iron-defense",
    "magnet-pull",
    "meteor-mash",
    "smart-strike",
    "bulk-up"
  ],
  "evolution_chain": {
    "id": 325,
    "item": null,
    "species": [
      {
        "name": "cobalion",
        "order": 639,
        "types": [
          PokeType.STEEL,
          PokeType.FIGHTING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 130,
    "speed": 147,
    "ability_power": 123
  },
  "stat_changes": [],
  "catch_rate": 3,
  "is_legendary": true,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
